module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAH9JREFUOE9jZKAQMFKonwGrAXdlGFR/M7GeYWBg5INY8P8Tw8/fBhovGe6jW4hiwA05tv/EuEjj0S+4Pup7gZArkG0HuRbDBaMGMDAMgjCQZf3HwMiIPX38//9f4/FvJuTEhhmNsmzbGRgZPLCmyP8MmzQe//LHawAxSZmqBgAASN42Ea+HBygAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/md-trash.png
// module id = 2625
// module chunks = 2